import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-collection-popup',
  templateUrl: './collection-popup.component.html',
  styleUrls: ['./collection-popup.component.scss']
})
export class CollectionPopupComponent implements OnInit {
form:FormGroup
head
date=new Date()
  constructor(
    private formBuilder:FormBuilder,
    public dialogRef: MatDialogRef<CollectionPopupComponent>,
    private toastr: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) { }

  ngOnInit(): void {
    this.form=this.formBuilder.group({
      collectionDate:[],
      comments:[]
    })
    console.log(this.data);
    
    this.head=this.data.title
  }
  Submit(){
    console.log(this.form.value)
    let value=this.form.value;
    this.dialogRef.close(value)
  }
  Close(){
    this.dialogRef.close()

  }
}
